// extracted by mini-css-extract-plugin
export var orderSummary = "_rq-0";
export var showMoreLessButton = "_rq-1";